export default function convertUTCToLocalDate(date: Date | null): Date | null {
  if (date == null) {
    return date;
  }
  let newDate = new Date(date);
  newDate = new Date(newDate.getUTCFullYear(), newDate.getUTCMonth(), newDate.getUTCDate());
  return newDate;
}
